/* eslint-disable global-require,import/no-unresolved,max-len,class-methods-use-this */
import React, { Component } from 'react'
import { Text } from 'react-native'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import styles from '../../styles'
import textStyles from '../../styles/text'
import BulletedListView from '../subcomponents/BulletedListView'
import * as ResourceManager from '../methods/ResourceManager'
import Hyperlink from '../subcomponents/Hyperlink'
import LightStageDetails from './LightStageDetails'
import { displayTelephoneLine } from '../methods/RegionalContentLookUp'
import * as tapEvents from '../../actions/tapEvents'

class TwoSendingWavesPage extends Component {
  getTelephoneLineIfYouSeeSection() {
    const {
      locale, t, patientManualTapped,
    } = this.props
    let returnObj
    if (displayTelephoneLine(locale)) {
      returnObj = (
        <BulletedListView
          testID="two-sending-if-you-see-telephone"
          headingText={t('common:connectionTypeTelephoneLineListTitle')}
        >
          <Text style={textStyles.detailText}>{t('twoSendingConnectionTypeTelephoneLineBulletOne')}</Text>
          <Text style={textStyles.detailText}>{t('common:connectionTypeTelephoneLineBulletTwo')}</Text>
          <Text style={textStyles.detailText}>{t('twoSendingConnectionTypeTelephoneLineBulletThree')}</Text>
          <Text style={textStyles.detailText}>{t('common:connectionTypeTelephoneLineBulletThree')}</Text>
          <Hyperlink
            accessibilityLabel={t('access:confirmSwitchSettingsLink')}
            testID="confirm-switch-settings"
            textStyle={textStyles.detailText}
            linkText={`${t('common:connectionTypeTelephoneLineBulletFivePart2')} `}
            beforeText={t('common:connectionTypeTelephoneLineBulletFivePart1')}
            afterText={t('common:inLatitudePatientManual')}
            onPress={() => patientManualTapped('switchSettings')}
          />
        </BulletedListView>
      )
    }
    return returnObj
  }

  render() {
    const { t, locale } = this.props
    return (
      <LightStageDetails
        analyticsEvent="TwoSendingWaves"
        sourceImage={ResourceManager.loadImage('two_sending_waves_header')}
        sourceImageStyle={{ width: 272, height: 59 }}
        accessibilityLabel={t('access:twoSendingWavesPageImage')}
      >
        <Text style={styles.lightStageHeader} testID="light-state-details-header">{t('common:yellowSendingTwoTitle')}</Text>
        <Text style={styles.lightStageDetailsHeading}>{t('whatItMeans')}</Text>
        { displayTelephoneLine(locale) ? (
          <BulletedListView
            testID="two-sending-what-it-means-bullet-list"
            headingText={t('twoSendingWhatItMeansListTitle')}
          >
            <Text testID="what-it-means-telephone-line-bullet" style={textStyles.detailText}>{t('twoSendingWhatItMeansBulletOne')}</Text>
          </BulletedListView>
        ) : <Text testID="two-sending-what-it-means-text-only" style={textStyles.bodyContentText}>{t('twoSendingWhatItMeansListTitle')}</Text>}
        <Text style={styles.lightStageDetailsHeading}>{t('ifYouSeeThis')}</Text>
        {this.getTelephoneLineIfYouSeeSection()}
        <BulletedListView
          headingText={t('common:connectionTypeCellularNetworkListTitle')}
        >
          <Text style={textStyles.detailText}>{t('twoSendingConnectionTypeCellularNetworkBulletOne')}</Text>
        </BulletedListView>
        <BulletedListView
          headingText={t('common:connectionTypeInternetListTitle')}
        >
          <Text style={textStyles.detailText}>{t('twoSendingConnectionTypeInternetBulletOne')}</Text>
        </BulletedListView>
        <BulletedListView
          headingText={t('common:verifyTroubleshootingListTitle')}
        >
          <Text style={textStyles.detailText}>{t('common:verifyTroubleshootingBulletTwo')}</Text>
        </BulletedListView>
      </LightStageDetails>
    )
  }
}

TwoSendingWavesPage.propTypes = {
  t: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  patientManualTapped: PropTypes.func.isRequired,
}

const actionCreators = {
  patientManualTapped: tapEvents.patientManualTapped,
}

const mapStateToProps = (state) => {
  const { storedData } = state
  return {
    locale: storedData.locale,
  }
}

export const TwoSendingWavesPageComponent = TwoSendingWavesPage

export default withTranslation(['indicatorLights', 'common'])(connect(mapStateToProps, actionCreators)(TwoSendingWavesPage))
